import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { FaCalendarAlt, FaArrowDown, FaPercentage, FaShieldAlt, FaUserShield, FaServer } from "react-icons/fa";
import TrustedCompanies from "../components/TrustedCompanies.js";
import TestimonialSection from "../components/imgration/TestimonialSection.js";
import CloudProviders from "../components/imgration/CloudProviders.js";
import MigrationGuides from "../components/imgration/MigrationGuides.js";
import WhyCloudMigration from "../components/imgration/WhyCloudMigration.js";
import OtherPlatforms from "../components/imgration/OtherPlatforms.js";
import CustomerPortalSection from "../components/imgration/CustomerPortalSection.js";
import ContactSection from "../components/imgration/ContactSection.js";
import AzureCostComparisonSection from "../components/imgration/AzureCostComparisonSection.js";
import AzureServiceMappingSection from "./AzureServiceMappingSection.js";
import AzureCaseStudySection from "../components/imgration/AzureCaseStudySection.js";
import AzureProcessSection from "../components/imgration/AzureProcessSection.js";
import WhySection from "../components/imgration/WhySection.js";
import AzureFAQSection from "../components/imgration/AzureFAQSection.js";
import OtherProvidersSection from "../components/imgration/OtherProvidersSection.js";
import AzureBlogSection from "../components/imgration/AzureBlogSection.js";
import ReviewsSection from "../components/imgration/ReviewsSection.js";
import Reaquestconsultation from "../components/imgration/RequestConsultation.js";
import { useNavigate } from "react-router-dom";


const AzureToHetzner = () => {
const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const navigate = useNavigate()
   const requstconsultation = ()=>{
const element = document.getElementById("contact");
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
  }
  
  return (
    <>
      <Helmet>
        <title>Azure Infrastructure Migration – Save up to 98% on Costs  | Ayanshtech Solutions</title>
        <meta
          name="description"
          content="Migrate your cloud infrastructure from Azure, Azure, Google Cloud, DigitalOcean, OVH, Scaleway, and Linode to cost-effective alternatives without compromising performance or security."
        />
        <meta property="og:title" content="Cloud Migration – Exit Expensive Hyperscalers" />
        <meta property="og:description" content="Save up to 98% on cloud hosting costs. 100% GDPR compliant and EU hosting possible." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Reaquestconsultation isOpen={isModalOpen} onClose={closeModal} />
      {/* Main Container */}
      <section className="relative overflow-hidden  min-h-[calc(100svh-98px)] md:min-h-[calc(100vh-104px)] md:mt-[104px] flex items-center py-16" >
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 w-full z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div>
              <div className="mb-4 transition-all duration-700 opacity-100 translate-y-0">
                <span className="text-green-600 font-semibold text-xs uppercase tracking-wider">Cloud Migration</span>
                </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold  text-gray-800 mb-4 transition-all duration-700 delay-100 opacity-100 translate-y-0">Azure to  <span className="text-green-600"> Hetzner</span><span className="text-yellow-500"> Migration</span><br></br>
              <span className="text-xl md:text-3xl font-normal text-gray-600">Cut Your Cloud Costs by Up to 98%</span>
              </h1>
              <p className="text-base text-gray-600 md:text-lg  leading-relaxed mb-8 max-w-3xl mx-auto transition-all duration-700 delay-200 opacity-100 translate-y-0">We migrate your Azure infrastructure to Hetzner, including Virtual Machines, Azure SQL Databases, Blob Storage, and other services. Benefit from reliable German data centers, transparent pricing, and full GDPR compliance.</p>
              <div className="mb-8 flex flex-col items-center transition-all duration-700 delay-300 opacity-100 translate-y-0">
                <div className="flex items-center gap-2 flex-wrap mb-4">
                  <div className="bg-gray-800 rounded-lg p-2 border border-white/10">
                    <img src="../assets/images/migration/aws-logo-bbde8644fb813e350642eeca4ccbbb8c.png" alt="Azure" className="h-5 w-auto brightness-0 invert opacity-70"/>
                  </div>
                  <div className="bg-gray-800 rounded-lg p-2 border border-white/10">
                    <img src="../assets/images/migration/azure-logo-128e2443446487b0e0130921c8c46662.png" alt="Azure" className="h-5 w-auto brightness-0 invert opacity-70"/>
                  </div>
                  <div className="bg-gray-800 rounded-lg p-2 border border-white/10">
                    <img src="../assets/images/migration/gcp-logo-abd3ce0748e83ff6e50c8074962dd13a.png" alt="Azure" className="h-5 w-auto brightness-0 invert opacity-70"/>
                  </div>
                  <div className="bg-gray-800 rounded-lg p-2 border border-white/10">
                    <img src="../assets/images/migration/do.png" alt="DigitalOcean" className="h-5 w-auto brightness-0 invert opacity-70"/>
                  </div>
                  <div className="bg-gray-800 rounded-lg p-2 border border-white/10">
                    <img src="../assets/images/migration/ovh-logo-9c8b279744ba2d672c201087fd859c2b.png" alt="Azure" className="h-5 w-auto brightness-0 invert opacity-70"/>
                  </div>
                </div>
               <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl">
  {/* Up to 98% cheaper */}
  <div className="bg-white/5 rounded-lg p-3 border border-gray-500">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-800 mx-auto mb-1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 2.821.879 3.992 0 1.171-.879 1.171-2.301 0-3.18-1.171-.879-2.821-.879-3.992 0l-.879.659a2.25 2.25 0 01-3.181-3.181l3.008-3.008a4.5 4.5 0 016.364 0l.227.227M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <p className="text-gray-800 text-xs font-medium text-center">Cost-Optimized Infrastructure</p>
  </div>

  {/* 100% EU hosting possible */}
  <div className="bg-white/5 rounded-lg p-3 border border-gray-500">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-800 mx-auto mb-1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605" />
    </svg>
    <p className="text-gray-800 text-xs font-medium text-center"> Scalable & Reliable Hosting</p>
  </div>

  {/* GDPR compliant */}
  <div className="bg-white/5 rounded-lg p-3 border border-gray-500">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-800 mx-auto mb-1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
    </svg>
    <p className="text-gray-800 text-xs font-medium text-center"> Security & Compliance Focused</p>
  </div>

  {/* Minimal downtime */}
  <div className="bg-white/5 rounded-lg p-3 border border-gray-500">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-800 mx-auto mb-1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
    </svg>
    <p className="text-gray-800 text-xs font-medium text-center">Minimal Service Disruption</p>
  </div>
</div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 justify-center transition-all duration-700 delay-400 opacity-100 translate-y-0">
                <button onClick={openModal}  className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-green-500 text-white text-sm font-semibold rounded-lg hover:bg-brand-hover transition-all cursor-pointer">
                <svg className="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path>
                </svg>Request Consultation</button>
                
                </div>
                <TrustedCompanies/>
            </div>
          </div>
        </div>
      </section>
            <div className=" border-white/5">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <p className="text-xs leading-relaxed text-gray-600 " role="note">
              The names, logos, and trademarks mentioned on this website are the property of their respective owners. References to platforms such as Microsoft Azure, AWS, Google Cloud, Hetzner, Proxmox, and others are provided solely for informational purposes.

Ayanshtech Solutions is an independent technology service provider and is not affiliated with, endorsed by, sponsored by, or officially connected with any of these companies. We provide independent cloud migration, infrastructure management, DevOps, hosting, server administration, and technical support services to businesses worldwide.
            </p>
          </div>
        </div>
 
      <TestimonialSection/>
      <AzureCostComparisonSection requstconsultation={requstconsultation}/>
      <AzureServiceMappingSection/>
      <AzureCaseStudySection/>
      <AzureProcessSection/>
      <WhySection/>
      <AzureFAQSection/>
      <section className="py-10 bg-gradient-to-br from-green-600 via-blue-600 to-blue-600">
<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
  <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Ready to Modernize Your Infrastructure?</h2>
  <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">ell us about your current environment and business goals. Our team will review your requirements and recommend the most effective migration and optimization strategy.</p>
  <div className="flex flex-col sm:flex-row gap-4 justify-center">
    <button onClick={requstconsultation} className="inline-flex items-center justify-center px-8 py-4 bg-green-600 text-white font-bold rounded-xl hover:bg-green-700 transform hover:scale-105 transition-all duration-300 shadow-lg">Request Free Consultation
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" className="ml-2 w-5 h-5">
      <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"></path>
      </svg>
      </button>
      <a className="inline-flex items-center justify-center px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-xl hover:bg-white/10 transition-all duration-300" href="/contactUs">Contact Our Team</a>
      </div>
      <p className="mt-6 text-white/70 text-sm">Free Initial Assessment • Expert Guidance • Fast Response • Secure & Reliable Solutions</p>
      </div>
      </section>
          <OtherProvidersSection/>
            <section className="py-8 ">
              <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">Open-Source Infrastructure Solutions</h2>
                <p className="text-gray-600 text-center mb-8 max-w-2xl mx-auto">Build scalable and cost-effective environments using trusted open-source technologies.</p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <a className="bg-gray-50 rounded-xl p-4 text-center hover:bg-green-50 transition-colors border border-gray-200 hover:border-blue-300" href="#">
                  <p className="font-bold text-gray-900">Coolify</p>
                  <p className="text-xs text-gray-500">Application Deployment Platform</p>
                  </a>
                  <a className="bg-gray-50 rounded-xl p-4 text-center hover:bg-green-50 transition-colors border border-gray-200 hover:border-blue-300" href="#">
                  <p className="font-bold text-gray-900">Grafana</p>
                  <p className="text-xs text-gray-500">Monitoring & Analytics Solution</p></a>
                  <a className="bg-gray-50 rounded-xl p-4 text-center hover:bg-green-50 transition-colors border border-gray-200 hover:border-blue-300" href="#">
                  <p className="font-bold text-gray-900">PostgreSQL</p>
                  <p className="text-xs text-gray-500">Enterprise Database Platform</p></a>
                  <a className="bg-gray-50 rounded-xl p-4 text-center hover:bg-green-50 transition-colors border border-gray-200 hover:border-blue-300" href="#">
                  <p className="font-bold text-gray-900">Keycloak</p>
                  <p className="text-xs text-gray-500">Identity & Access Management</p></a>
                  </div>
                  </div>
                  </section>
                  <section className="py-6 "><div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8"><a className="flex items-center justify-between bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200" href="/hetzner-cloud-services"><div className="flex items-center gap-4">
                    <img src="../assets/images/migration/hetzner-logo-c38db8c1cd1f5aef63bed4374a4fbeaf.png" alt="Hetzner" className="h-10 w-auto"/>
                    <div><p className="text-sm text-gray-500">Back to overview</p><p className="font-bold text-gray-900">All Hetzner Services</p>
                    </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" className="w-6 h-6 text-gray-400">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"></path>
                    </svg>
                    </a>
                    </div>
                    </section>
                    <AzureBlogSection/>
                    <ReviewsSection/>
                    
    {/* <CustomerPortalSection/> */}
    <ContactSection/>
    </>
  );
};

export default AzureToHetzner;
